import { AxiosPromise } from "axios";
import { Http } from "../Http";
import { getUserAccessToken } from "../selectors/Accounts";

export default class PrayerAndTalksService {
	public static prayerAndTalksSave(input: any) {
		return Http.axios()
			.post("/api/ChannelAssignment/assign", input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static prayerAndTalksGetDetail() {
		return Http.axios()
			.get("/api/ChannelAssignment/assigned-channels", {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static prayerAndTalksGetAllChannels() {
		return Http.axios()
			.get("/api/ChannelAssignment/channels", {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}
}